import { createFileRoute } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";

import apollo, { API_CMS_PROVIDER } from "@/helpers/apollo";
import Blog, {
  type BlogDataType,
  type BlogVariablesType,
  GET_BLOGS,
  PAGE_SIZE,
} from "@/pages/blog";

const fetchBlogs = createServerFn({ method: "GET" }).handler(async () => {
  const { data } = await apollo().query<BlogDataType, BlogVariablesType>({
    context: { clientName: API_CMS_PROVIDER },
    query: GET_BLOGS,
    variables: { pagination: { pageSize: PAGE_SIZE } },
  });

  return { blogs: data.blogs.data, pagination: data.blogs.meta.pagination };
});

export const Route = createFileRoute("/blog/")({
  component: BlogPage,
  head: () => ({
    links: [{ href: `${process.env.APP_URL}/blog`, rel: "canonical" }],
    meta: [{ title: "Morty blog" }],
  }),
  headers: () => ({
    "Cache-Control": "s-maxage=3600, stale-while-revalidate=86400",
  }),
  loader: () => fetchBlogs(),
});

function BlogPage() {
  const data = Route.useLoaderData();
  return <Blog {...data} />;
}
